"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitzedString = exports.arrayOfLangValues = exports.ImageSchema = exports.LangValueSchema = exports.arrayPreprocess = void 0;
const zod_1 = require("zod");
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const arrayPreprocess = (val) => {
    if (typeof val === 'undefined' || val === null)
        return [];
    return val;
};
exports.arrayPreprocess = arrayPreprocess;
exports.LangValueSchema = zod_1.z.object({
    lang: zod_1.z.string(),
    value: zod_1.z.string(),
});
exports.ImageSchema = zod_1.z.object({
    name: zod_1.z.string(),
    src: zod_1.z.string().url(),
});
exports.arrayOfLangValues = zod_1.z.preprocess(exports.arrayPreprocess, zod_1.z.array(exports.LangValueSchema)).optional();
const sanitzedString = () => zod_1.z.string().transform(sanitize_html_1.default);
exports.sanitzedString = sanitzedString;
//# sourceMappingURL=atomics.js.map